export default __webpack_public_path__ + "static/media/174hz-healing-and-pain-relief.a6b15143.ogg";